/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../types/schema.generated';

import gql from 'graphql-tag';
import { AgreementModalViewerFragmentDoc } from '../components/organisms/AgreementModal/AgreementModal.generated';
import { CreditCardRegistrationModalContractFragmentDoc } from '../features/contract/components/CreditCardRegistrationModal/CreditCardRegistrationModal.generated';
export type ContractType =
  | 'CORPORATE'
  | 'INDIVIDUAL'
  | 'UNKNOWN';

export type PaymentMethod =
  | 'STRIPE'
  | 'UNKNOWN';

export type TermType =
  /** プライバシーポリシー */
  | 'PRIVACY_POLICY'
  /** 通信の秘密 */
  | 'SECRECY_OF_COMMUNICATIONS'
  /** 利用規約 */
  | 'TERMS_OF_SERVICE';

export type ModalManagerViewerFragment = { id: string, requiredAgreementTerms: Array<{ id: string, type: Types.TermType, title: string, body: MarkdownString }> };

export type ModalManagerContractFragment = { contractType: Types.ContractType, paymentMethod: Types.PaymentMethod, isCreditCardAvailable: boolean };

export const ModalManagerViewerFragmentDoc = gql`
    fragment ModalManagerViewer on Viewer {
  ...AgreementModalViewer
}
    ${AgreementModalViewerFragmentDoc}`;
export const ModalManagerContractFragmentDoc = gql`
    fragment ModalManagerContract on Contract {
  ...CreditCardRegistrationModalContract
  contractType
  paymentMethod
}
    ${CreditCardRegistrationModalContractFragmentDoc}`;